import React, { FC, useCallback, useRef } from 'react'

import { styled } from '@linaria/react'
import { createPortal } from 'react-dom'
import { useDispatch } from 'react-redux'

import { rollbackAction } from 'actions/rating/rollbackAction'
import { openStoreFrontVipSliderRollbackAction } from 'actions/storefront/openStoreFrontAction'
import { ReturnSvg } from 'components/designSystem/svgr/ReturnSvg'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { useVipCurrentUser } from 'hooks/useVipCurrentUser'

import { ROLLBACK_RATING_BUTTON } from '../Rating.constants'

export const Rollback: FC<{ isPromo?: boolean }> = ({ isPromo }) => {
  const dispatch = useDispatch()
  const hasVip = useVipCurrentUser()
  const loadingRef = useRef<boolean>(false)
  const { votedPhotosCounter, rollbackLoading } = useShallowEqualSelector(
    ({ photoRatingNext: { votedPhotosCounter, rollbackLoading } }) => ({
      votedPhotosCounter,
      rollbackLoading,
    })
  )

  const portalNode =
    process.env.browser && document.getElementById(ROLLBACK_RATING_BUTTON)

  const handleRollback = useCallback(() => {
    if (!rollbackLoading && !loadingRef.current) {
      loadingRef.current = true

      if (hasVip) {
        dispatch(rollbackAction())
      } else {
        dispatch(openStoreFrontVipSliderRollbackAction())
      }

      loadingRef.current = false
    }
  }, [dispatch, hasVip, rollbackLoading])

  if (portalNode && !isPromo && votedPhotosCounter > 0) {
    return createPortal(
      <RatingRevertPhoto
        width={24}
        height={24}
        onClick={handleRollback}
        data-name="revert-action"
      />,
      portalNode
    )
  }
}

const RatingRevertPhoto = styled(ReturnSvg)`
  cursor: pointer;
`
